import axios from 'axios'
import { Product } from '@libs/types/generated/rates-research-api'

const getAll = async (): Promise<Product[]> => {
  const response = await axios.post(
    `${process.env.NEXT_PUBLIC_PRODUCTS_SERVICE_URL}/search`,
    {
      query: {},
      omit_fields: ['attributes', 'market_type', 'locations'],
      disable_cache: false
    }
  )

  const products: Product[] = response.data.results

  return products.filter(product => {
    return (
      product.vertical !== 'mortgage' ||
      product.dimensions.points_band === 'all'
    )
  })
}

const productsApi = {
  getAll
}

export default productsApi
